import React from "react";
import { X, Utensils } from "lucide-react";
import { LoginResponse } from "../types";
import { useTranslation } from "react-i18next";
import Login from "./Login";
import Register from "./Register";
import managerLogo from "../assets/manager_mini_logo.png";

interface AuthModalProps {
  mode: "login" | "register" | "forgotPassword";
  onLogin: (user: LoginResponse) => void;
  onClose: () => void;
  onSwitchMode: (mode: "login" | "register" | "forgotPassword") => void;
}

const AuthModal: React.FC<AuthModalProps> = ({
  mode,
  onLogin,
  onClose,
  onSwitchMode,
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100">
          <div className="flex items-center space-x-3">
            {/* <div className="bg-orange-500 p-2 rounded-lg"> */}
            <div className="flex items-center cursor-pointer">
              {/* <Utensils className="h-5 w-5 text-white" /> */}
              <img
                src={managerLogo}
                alt={t("header.appName")}
                className="h-10"
              />
            </div>
            <h2 className="text-xl font-bold text-black">
              {mode === "login"
                ? t("auth.login")
                : mode === "forgotPassword"
                ? t("auth.forgotPasswordTitle")
                : t("auth.register")}
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors duration-200"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          {mode === "login" || mode === "forgotPassword" ? (
            <Login onSwitchMode={onSwitchMode} onLogin={onLogin} />
          ) : (
            <Register onRegister={onLogin} />
          )}

          {/* Switch Mode */}
          {mode !== "forgotPassword" && (
            <div className="mt-6 text-center">
              <p className="text-gray-600 text-sm">
                {mode === "login"
                  ? t("auth.dontHaveAccount")
                  : t("auth.alreadyHaveAccount")}
                <button
                  onClick={() =>
                    onSwitchMode(mode === "login" ? "register" : "login")
                  }
                  className="ml-2 text-orange-500 font-medium hover:text-orange-600 transition-colors duration-200"
                >
                  {mode === "login" ? t("auth.signUp") : t("auth.login")}
                </button>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthModal;
